import React from 'react'
import SurgicalSchedulingContextWrapper from 'presentation/hospital/layouts/Home/SchedulingSector/context'
import ContainerNew from 'presentation/hospital/components/ContainerNew'
import HospitalScheduleSurgeryRequestsLayout from 'presentation/hospital/layouts/Home/SchedulingSector/ScheduleSurgeryRequests'

const HospitalScheduleSurgeryRequests = () => {
  return (
    <SurgicalSchedulingContextWrapper>
      <ContainerNew>
        <HospitalScheduleSurgeryRequestsLayout />
      </ContainerNew>
    </SurgicalSchedulingContextWrapper>
  )
}

export default HospitalScheduleSurgeryRequests
